var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvasWrapperEl",class:'ametras-field ametras-field--signature wrapper ' + _vm.paddingDefinition + ' ' + _vm.marginDefinition,style:({
         height: _vm.height + 'px'
     })},[_c('canvas',{ref:"canvasEl",staticClass:"canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }